import { makeUserComponentsAction } from '~/jet/models';
import type { ActionModel } from '@jet/environment';
import type { JetPerform } from '~/jet';

/**
 *
 * Centralized function to perform a favorite action.
 *
 * @method toggleFavorite
 * @param id id of the content
 * @param type singular content type (artist, track, etc.)
 * @param storefront storefront of the user performing the action
 * @param inFavorites boolean indicating if content is already favorited
 * @param {Jet.Perform} perform perform function sourced from getJetPerform()
 * @return {void}
 */
export function toggleFavorite(
    id: string,
    entityType: string,
    storefront: string,
    inFavorites: boolean,
    perform: (actionModel: ActionModel) => JetPerform,
): void {
    const favoriteAction = makeUserComponentsAction(
        `/query/command/favorites/${storefront}`,
        'perform',
        {
            id,
            entityType,
            favorite: !inFavorites,
        },
    );

    perform(favoriteAction);
}
